import { PortfolioList, EVENTS_CFG } from "@/components/Portfolio";
export default function EventsPortfolio() {
  return <PortfolioList cfg={EVENTS_CFG} />;
}
